import React, { Component } from "react";

import Icon from "../icon";

export default class NumericStepper extends Component {
  render() {
    const { onChange, quantity, min, max, layout = "boxed", destinationColors = false } = this.props;

    let styles = "";

    if(layout === "boxed") styles = "rounded-lg text-[color:var(--highlightedSecondaryColor,rgb(17,_55,_102))] flex justify-center items-center bg-[#f4f4f9] w-8 h-8";
    if(layout === "rounded") styles = `rounded-full border ${destinationColors ? "border-[color:var(--highlightedSecondaryColor)] text-[color:var(--highlightedSecondaryColor)]" : "border-[#EAEAF2] text-[color:var(--highlightedSecondaryColor,rgb(17,_55,_102))]"}  flex justify-center items-center w-8 h-8`

    return (
      <div className="flex gap-1 items-center generalTextBold">
        <button
          disabled={quantity === min}
          onClick={() => onChange(quantity - 1)}
          className={styles + ` ${quantity === min ? 'grayscale opacity-50' : ''}`}
        >
          <Icon icon="Minor" className={`w-4 h-4 ${destinationColors ? "text-[color:var(--highlightedSecondaryColor)]" : ""}`} />
        </button>
        <div className={`searchWidgetNumber min-w-[16px] flex justify-center ${destinationColors ? "text-[color:var(--highlightedSecondaryColor)]" : ""}`}>{quantity}</div>
        <button
          disabled={quantity === max}
          onClick={() => onChange(quantity + 1)}
          className={styles + ` ${quantity === max ? 'grayscale opacity-50' : ''}`}
        >
          <Icon icon="Plus" className={`w-4 h-4 ${destinationColors ? "text-[color:var(--highlightedSecondaryColor)]" : ""}`} />
        </button>
      </div>
    )
  }
}